import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PT from 'prop-types';
import React from 'react';

import fontAwesomeStyles from '@fortawesome/fontawesome-free/css/all.css';

import s from './HowItWorksStepBox.scss';

function HowItWorksStepBox(props) {
  const { instructions, stepNum, title } = props;
  return (
    <div className={cx(s.stepBox, `step-${stepNum}`)}>
      <span className={s.stepNum}>{stepNum}</span>
      <span className={s.title}>{title}</span>
      {instructions.map((text, idx) => {
        const key = `text-${idx}`;
        return (
          <p key={key} className={s.instructionText}>
            {text}
          </p>
        );
      })}
    </div>
  );
}

HowItWorksStepBox.propTypes = {
  instructions: PT.arrayOf(PT.string).isRequired,
  stepNum: PT.number.isRequired,
  title: PT.string.isRequired,
};

export default withStyles(fontAwesomeStyles, s)(HowItWorksStepBox);
